module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_stores@3x-0ea8c31e5e9e2f820107a19fdfc95f1a.webp";